module.exports = __webpack_public_path__ + "static/logoIcon-c7429c05b10f7b3029b451039e17afdc.png";